(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["card-expansions-carousel"] && !Shopify.designMode) return;
  try {
    
(function() {
  const track = document.getElementById('carouselTrack-{{ section.id }}');
  if (!track) return;

  // Calcola la durata in base al numero di card e alla velocità desiderata
  const cards = track.querySelectorAll('.carousel-card:not(.carousel-card--clone)');
  const cardCount = cards.length;
  // 3 secondi per card = scorrimento fluido proporzionale
  const totalDuration = cardCount * 12; // secondi totali per scorrere tutto il set

  track.style.animationDuration = totalDuration + 's';

  // Pause on hover (touch support)
  track.addEventListener('mouseenter', () => track.classList.add('is-paused'));
  track.addEventListener('mouseleave', () => track.classList.remove('is-paused'));
  track.addEventListener('touchstart', () => track.classList.add('is-paused'), { passive: true });
  track.addEventListener('touchend', () => {
    setTimeout(() => track.classList.remove('is-paused'), 2000);
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
